import { FiAlignJustify } from "react-icons/fi";
import BreadCrumb from "./BreadCrumb";
import { UserDropdown } from "./UserDropdown";
import { NotificationBell } from "./NotificationBell";
import WorkspacesDropdown from "./WorkspacesDropdown";
import { X } from "lucide-react";
import Configurator from "./Configurator";
import { useState } from "react";
import { ChangeLanguage } from "./ChangeLanguage";
const Navbar = (props: {
  open: boolean;
  onOpenSidenav: () => void;
  brandText: string;
  secondary?: boolean | string;
  [x: string]: any;
}) => {
  const { onOpenSidenav, brandText, mini, hovered, open } = props;
  const [darkmode, setDarkmode] = useState(
    document.body.classList.contains("dark")
  );
  return (
    <nav
      className={`duration-175 linear fixed right-3 top-3 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/30 transition-all ${
        open
          ? mini === false
            ? "w-[calc(100vw_-_6%)] md:w-[calc(100vw_-_8%)] lg:w-[calc(100vw_-_6%)] xl:w-[calc(100vw_-_350px)] 2xl:w-[calc(100vw_-_365px)]"
            : mini === true && hovered === true
            ? "w-[calc(100vw_-_6%)] md:w-[calc(100vw_-_8%)] lg:w-[calc(100vw_-_6%)] xl:w-[calc(100vw_-_350px)] 2xl:w-[calc(100vw_-_365px)]"
            : "w-[calc(100vw_-_6%)] md:w-[calc(100vw_-_8%)] lg:w-[calc(100vw_-_6%)] xl:w-[calc(100vw_-_180px)] 2xl:w-[calc(100vw_-_195px)]"
          : "w-[calc(100vw_-_6%)] md:w-[calc(100vw_-_8%)] lg:w-[calc(100vw_-3.2%)]"
      }  p-2 backdrop-blur-xl dark:bg-[#0b14374d] md:right-[30px] md:top-4 xl:top-[20px]`}
    >
      <BreadCrumb brandText={brandText} />

      <div className="relative mt-[3px] flex h-[61px] items-center justify-around gap-2 rounded-full   bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:gap-1 xl:gap-2">
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white"
          onClick={onOpenSidenav}
        >
          {open ? (
            <X className="h-5 w-5" />
          ) : (
            <FiAlignJustify className="h-5 w-5" />
          )}
        </span>
        <Configurator
          mini={props.mini}
          setMini={props.setMini}
          theme={props.theme}
          setTheme={props.setTheme}
          darkmode={darkmode}
          setDarkmode={setDarkmode}
        />
        <WorkspacesDropdown />
        <NotificationBell />
        <ChangeLanguage />
        <UserDropdown />
      </div>
    </nav>
  );
};

export default Navbar;
